<template>
  <VBusHelper
    :actionOnMounted="
      () =>
        $bus.emit($constants.EVENTS.PHONE.RESOLVE, {
          phoneNumber: phoneNumber,
          countryCode: countryCode,
          phonePrefix: phonePrefix,
          originalKey: phoneNumber
        })
    "
    :key="phoneNumber"
  />
  <div
    v-if="$stores.phoneResolver?.state?.phoneData?.[phoneNumber]?.error"
  >
    <span class="text-red-500 font-bold">
      {{
        $stores.phoneResolver?.state?.phoneData?.[phoneNumber]?.error
      }}
    </span>
  </div>
  <div
    v-else-if="
      $stores.phoneResolver?.state?.phoneData?.[phoneNumber]?.data
    "
    class="flex items-center gap-2"
  >
    <slot
      :carrier="
        $stores.phoneResolver?.state?.phoneData?.[phoneNumber]?.data
          ?.carrier
      "
      :countryCode="
        $stores.phoneResolver?.state?.phoneData?.[phoneNumber]?.data
          ?.countryCode
      "
      :isValid="
        $stores.phoneResolver?.state?.phoneData?.[phoneNumber]?.data
          ?.isValid
      "
      :data="
        $stores.phoneResolver?.state?.phoneData?.[phoneNumber]?.data
      "
    >
      <span>
        {{
          $stores.phoneResolver?.state?.phoneData?.[phoneNumber]?.data
            ?.carrier
        }}
      </span>
      <span class="text-gray-500 text-sm">({{ phoneNumber }})</span>
      <span
        v-if="
          $stores.phoneResolver?.state?.phoneData?.[phoneNumber]?.data
            ?.countryCode
        "
        class="text-xs bg-gray-200 px-2 py-1 rounded"
      >
        {{
          $stores.phoneResolver?.state?.phoneData?.[phoneNumber]?.data
            ?.countryCode
        }}
      </span>
    </slot>
  </div>
  <div
    v-else-if="
      $stores.phoneResolver?.state?.phoneData?.[phoneNumber]?.loading
    "
    class="shimmerContainer"
  >
    <span>Recherche..</span>
  </div>
  <div v-else>...</div>
</template>

<script setup>
import { getCurrentInstance, watch } from 'vue';
const emit = defineEmits(['loading', 'resolved', 'error']);
const { proxy } = getCurrentInstance();

const props = defineProps({
  phoneNumber: String,
  countryCode: String,
  phonePrefix: String,
});


watch(
  () => proxy.$stores.phoneResolver?.state?.phoneData?.[props.phoneNumber],
  (newVal) => {
    if (newVal?.loading) {
      emit('loading', newVal);
    } else if (newVal?.data) {
      emit('resolved', newVal.data);
    } else if (newVal?.error) {
      emit('error', newVal);
    }
  },
  { deep: true }
);
</script>
